import { supabase } from '@/integrations/supabase/client';

/** Registra un clic en WhatsApp o teléfono para estadísticas de contacto. */
export const trackContactClick = (channel: 'whatsapp' | 'phone') => {
  supabase
    .from('contact_clicks')
    .insert({ channel, page: window.location.pathname })
    .then(({ error }) => {
      if (error) console.warn('trackContactClick:', error.message);
    });
};
